import { useAtomValue } from 'jotai';
import { useNavigate } from 'react-router';

import { ErrorScreen, StudentSettings } from '@screens';
import { currentUserIdAtom, activityUserIdAtom } from '@store';

import { NavigateToActivitiesButton } from '../components/BackToActivitiesButton/BackToActivitiesButton';
import { LINKS } from '../utils/routes';

export const StudentSettingsScreen = () => {
    const activeUserId = useAtomValue(activityUserIdAtom);
    const currentUserId = useAtomValue(currentUserIdAtom);
    const navigate = useNavigate();

    if (!activeUserId || activeUserId === currentUserId)
        return <ErrorScreen message="No student selected" action={<NavigateToActivitiesButton />} />;
    return <StudentSettings onClose={() => navigate(LINKS.getFullActivity())} />;
};
